import request from '@/config/axios'

const BASE = '/hotel/platform/profile-change'
export const getPage = (params: any) => request.get({ url: `${BASE}/page`, params })
export const audit = (data: any) => request.post({ url: `${BASE}/audit`, data })
export const getSensitive = (id: string | number) =>
  request.get({ url: `${BASE}/sensitive`, params: { id } })
